import React, { useEffect, useState } from "react";
import { getVideo } from "../Service/Api";
import Header from '../Component/Header'
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const KinderVideo = () => {
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState("All"); // Default to "All"
    const [yearRanges, setYearRanges] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const galleryData1 = await getVideo();
const galleryData = galleryData1.filter((item)=>item.school === "Junior");
            setData(galleryData);

            // Extract unique years
            const uniqueYears = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.date) {
                        const year = new Date(item.date).getFullYear(); // Extract only the year
                        console.log(year)
                        return [year];
                    } else {
                        return [];
                    }
                }))
            );

            // Remove the map function for generating year ranges
            const uniqueYearRanges = uniqueYears.map(year => {
                return `${year}`;
            });

            uniqueYearRanges.sort((a, b) => b - a);
            console.log("Unique Year Ranges:", uniqueYearRanges); // Log uniqueYearRanges
            setYearRanges(uniqueYearRanges);
        };
        fetchData();
    }, []);

    useEffect(() => {
        // Filter data based on selected year
        let filteredData = data;
        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date) {
                    const year = new Date(item.date).getFullYear();
                    return parseInt(selectedYear) === year;
                } else {
                    return false;
                }
            });
        }
        setFilteredData(filteredData);
    }, [selectedYear, data]);
    return (
        <>
            <Header />
            <Breadcrumb title="Video Gallery" mid="Video &nbsp; &nbsp;|" tabName="Video Gallery" />
            <div className="innerPage">
                <div className="container">
                    <div className="row inner_cont">
                        <div className="col-lg-12">
                            <div className="chooseyear">
                                <select id="chooseddlYear"
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                    className="monthSelect">
                                    <option value={"All"}>All</option>
                                    {yearRanges.map((yr) => (
                                        <option key={yr} value={yr}>{yr}</option>
                                    ))}
                                </select>

                            </div>
                            <div className="clr"></div>
                            <div className="row">
                                {filterData.length > 0 && filterData.map((item, index) => (
                                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch" key={index}>
                                        <div className="video-gallery">
                                            <Link to={item.videoUrl} target="_blank">
                                                <div className="video-pg-img">
                                                   {item.attachments.length>0?
                                                    <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments}`} alt="Nirmala Convent School, Rajkot" className="img-fluid mx-auto d-block" /></LazyLoad>:
                                                    <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/youtube-video.png" alt="Nirmala Convent School, Rajkot" className="img-fluid mx-auto d-block" /></LazyLoad>
                                                   } 
                                                    <div className="youtube-icon-pg">
                                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/youtube.png" alt="Nirmala Convent School, Rajkot" className="img-fluid" />
                                                    </div>
                                                </div>
                                                <h5>{item.title}</h5>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default KinderVideo;